import store from '../store';

export const isRxAdminEnabled = (): boolean => {
  const state = (store?.getState()?.app?.entities?.features ?? {})['rxadmin'] ?? false;
  return state?.data?.enabled;
};
